import { isEmpty, map } from 'lodash/fp';

import { ArticleTag, Maybe } from '../../../../types/__codegen__/sanity/graphql';
import { Tag, TagWrapper } from './styles';

type ArticleTagsProps = {
  tags: Maybe<Array<Maybe<ArticleTag>>> | undefined;
  isLeftAligned?: boolean;
};

const ArticleTags = ({ tags, isLeftAligned }: ArticleTagsProps) => {
  if (isEmpty(tags)) {
    return null;
  }
  return (
    <TagWrapper isLeftAligned={isLeftAligned}>
      {map((tag) => {
        if (!tag) {
          return null;
        }
        return <Tag key={tag.name}>{tag.name}</Tag>;
      }, tags)}
    </TagWrapper>
  );
};

export default ArticleTags;
